import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/Core/ActionButton/ActionButton";
import AppText from "../../components/Core/AppText/AppText";
import TableLayout, {
	ActionsTableDataStyles,
	ActionsTableHeadStyles,
} from "../../components/Layout/TableLayout";
import EmptyState from "../../components/Shared/EmptyState/EmptyState";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import { DATE_TIME_FORMAT_TYPES } from "../../configs/constants/DateTimeFormatTypes";
import { useModalStore } from "../../hooks/modal.hooks";
import Consultant, { Absences } from "../../models/Consultant";
import { useConsultantAbsence, useDeleteAbsence } from "../../networking/consultant.hooks";
import { ConfirmModalProps, useConfirmModalStore } from "../../stores/confirmModal.store";
import { toast } from "../../utils/toast";

const ConsultantAbsenceTab: React.FC<{ consultant: Consultant }> = ({ consultant }) => {
	const modalStore = useConfirmModalStore();
	const { absences, isLoading } = useConsultantAbsence({ consultantId: consultant.id });
	const { mutateAsync: deleteAbsenceMutateAsync } = useDeleteAbsence();
	const toggleModal = useModalStore((state) => state.toggleAbsenceModal);

	const { t } = useTranslation();

	const handleDelete = async (absenceId: string, force?: boolean) => {
		try {
			await deleteAbsenceMutateAsync({
				consultantId: consultant.id,
				absenceId,
				force,
				silent: true,
			});
			toast.successGeneric();
		} catch (e: any) {
			if (e?.error?.code === "ABSENCE_HAD_USED") {
				modalStore.newModal({
					title: "absence.delete.warning.title",
					text: "absence.delete.warning.text",
					acceptButtonText: "absence.delete.warning.confirm",
					rejectButtonText: "CANCEL",
					onAccept: () => handleDelete(absenceId, true),
					onReject: () => {},
					type: "DANGER",
				});
			} else {
				toast.apiError(e?.error?.code);
			}
		}
	};

	const deleteAbsenceConfirm = (absenceId: string) => {
		const unblockCustomerConfirmModal: ConfirmModalProps = {
			title: "absence.delete.title",
			text: "absence.delete.text",
			acceptButtonText: "YES",
			rejectButtonText: "NO",
			onAccept: () => handleDelete(absenceId),
			onReject: () => {},
			type: "SUCCESS",
		};
		modalStore.newModal(unblockCustomerConfirmModal);
	};

	const editAbsence = (absence: Absences) => {
		toggleModal({ consultantId: consultant.id, absenceId: absence.id });
	};

	// const [vDays, setVDays] = useState<Date[]>([]);

	// const excludeOverlapDates = (startDate: Moment, endDate: Moment) => {
	// 	var now = startDate.clone(),
	// 		dates = [];

	// 	while (now.isSameOrBefore(endDate)) {
	// 		dates.push(now.toDate());
	// 		now.add(1, "days");
	// 	}

	// 	return dates;
	// };

	// useEffect(() => {
	// 	let vacationDates: Date[] = [];

	// 	absences.forEach((ab) => {
	// 		const d = excludeOverlapDates(moment(ab.startDate), moment(ab.endDate));

	// 		vacationDates = [...vacationDates, ...d];
	// 	});
	// 	setVDays([...vacationDates]);
	// }, [absences]);

	return (
		<div>
			{/* <AppText margin="0.25rem 0" weight="bold" color="grayText">
				{t("ABSENCE")}
			</AppText> */}
			{isLoading ? (
				<LoadingIndicator />
			) : (
				<React.Fragment>
					<TableLayout>
						<table>
							<thead>
								<tr>
									<th>{t("FROM")} </th>
									<th>{t("TO")}</th>
									<th>{t("REASON")}</th>
									<th>{t("CREATED_BY")}</th>
									<ActionsTableHeadStyles>
										<ActionButton onClick={() => toggleModal({ consultantId: consultant.id })}>
											{t("REGISTER_ABSENCE")}
										</ActionButton>
									</ActionsTableHeadStyles>
								</tr>
							</thead>
							<tbody>
								{absences && absences.length > 0 && (
									<React.Fragment>
										{absences.map((absence, index) => {
											return (
												<tr key={index}>
													<td onClick={() => editAbsence(absence)}>
														{moment(absence?.startDate).format("YYYY-MM-DD, HH:mm")}
													</td>
													<td onClick={() => editAbsence(absence)}>
														{moment(absence?.endDate).format(DATE_TIME_FORMAT_TYPES.DATE)}
													</td>
													<td onClick={() => editAbsence(absence)}>{t(absence.type as any)}</td>
													<td onClick={() => editAbsence(absence)}>
														{absence.metadata?.createdBy?.firstName}{" "}
														{absence.metadata?.createdBy?.lastName}
													</td>
													<ActionsTableDataStyles onClick={() => deleteAbsenceConfirm(absence.id)}>
														<img alt="remove-shift" src="/svg/close-icon.svg" />
													</ActionsTableDataStyles>
												</tr>
											);
										})}
									</React.Fragment>
								)}
							</tbody>
						</table>
						{absences && absences.length === 0 && <EmptyState margin="2rem 0" label="NO_JOBS" />}
					</TableLayout>
				</React.Fragment>
			)}
		</div>
	);
};

export default ConsultantAbsenceTab;
